import React from 'react';
import styled from 'styled-components';
import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';
import ContentWrapper from 'components/core/content-wrapper';

import useColors from 'hooks/use-colors';
import ProductImage from 'components/product-image';
import ProductImages from 'components/product-images';

export function Container({ children, ...otherProps }) {
  const colors = useColors();

  return (
    <ContentWrapper bg={colors.white} margin='4px 20px 0;' {...otherProps}>
      <RootContainer>{children}</RootContainer>
    </ContentWrapper>
  );
}

const RootContainer = styled.div`
  margin: 0 auto;
  max-width: 1052px;
  min-height: 100%;
  padding: 44px 0 140px 0;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 22px 0 140px 0;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: ${({ isMobile }) => (isMobile ? `center` : `flex-start`)};
  flex-direction: ${({ isMobile }) => (isMobile ? `column` : `row`)};
`;

export const Details = styled.div`
  flex: 1 0 0%;
  min-width: 0;
  margin: ${({ isMobile }) => (isMobile ? `0 28px` : 0)};
  margin-top: 15px;
  width: 100%;
`;

export function Images({ product, isMobile }) {
  // eslint-disable-next-line lodash/prefer-lodash-method
  const activeImages = product.images?.filter((img) => img.active);

  return (
    <ImagesContainer isMobile={isMobile}>
      {activeImages?.length > 0 ? (
        <ProductImages images={product.images} />
      ) : (
        <ProductImage product={product} width={344} height={344} />
      )}
    </ImagesContainer>
  );
}

const ImagesContainer = styled.div`
  flex: ${({ isMobile }) => (isMobile ? `0 0 0` : `0 0 344px`)};
  margin-right: ${({ isMobile }) => (isMobile ? 0 : `62px`)};
  min-width: 0;
  padding-top: 16px;
  padding-bottom: ${({ isMobile }) => (isMobile ? `18px` : 0)};
  border-radius: 3px;
  img {
    border-radius: 3px;
  }
`;

export const AddToCartContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  margin-bottom: 39px;
`;

export const CarouselContainer = styled.div`
  margin-bottom: 34px;
`;

export const TaxText = styled.p`
  margin-bottom: 35px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey[60]};
`;
